import React from "react";
import { AlertTriangle, Info, Shield } from "lucide-react";
import { legalNotice } from "../data/mock";

export const Notice = () => {
  return (
    <section id="hinweis" className="py-20 bg-primary/5">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Warning Card */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Header */}
          <div className="bg-accent/10 border-b border-accent/20 px-8 py-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-accent/20 flex items-center justify-center flex-shrink-0">
                <AlertTriangle className="w-6 h-6 text-accent" />
              </div>
              <div>
                <h2 className="text-xl sm:text-2xl font-bold text-primary">
                  {legalNotice.title}
                </h2>
                <p className="text-secondary text-sm mt-1">
                  Bitte beachten Sie die folgenden Hinweise
                </p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="p-8">
            <p className="text-secondary leading-relaxed text-base">
              {legalNotice.text}
            </p>

            {/* Key Points */}
            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              <div className="flex items-start gap-3 p-4 bg-neutral-light rounded-xl">
                <Info className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-primary text-sm">Keine DIN 4420</h4>
                  <p className="text-secondary text-sm mt-1">
                    Reparierte Beläge dürfen nicht als DIN 4420 gekennzeichnet werden.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-neutral-light rounded-xl">
                <Shield className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-primary text-sm">Einzelfallprüfung</h4>
                  <p className="text-secondary text-sm mt-1">
                    Für den Einsatz kann eine baurechtliche Zustimmung erforderlich sein.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
